__turbopack_context__.v({
  "body": "yzz-4W_body",
  "card": "yzz-4W_card" + " " + "yzz-4W_cardBase",
  "cardAligned": "yzz-4W_cardAligned" + " " + "yzz-4W_cardSubgrid" + " " + "yzz-4W_card" + " " + "yzz-4W_cardBase",
  "cardBase": "yzz-4W_cardBase",
  "cardHeaderAligned": "yzz-4W_cardHeaderAligned" + " " + "yzz-4W_cardSubgrid" + " " + "yzz-4W_card" + " " + "yzz-4W_cardBase",
  "cardSubgrid": "yzz-4W_cardSubgrid",
  "content": "yzz-4W_content",
  "date": "yzz-4W_date",
  "emptyCard": "yzz-4W_emptyCard" + " " + "yzz-4W_cardBase",
  "emptyDescription": "yzz-4W_emptyDescription",
  "emptyIcon": "yzz-4W_emptyIcon",
  "field": "yzz-4W_field" + " " + "yzz-4W_fieldBase",
  "fieldBase": "yzz-4W_fieldBase",
  "fieldRight": "yzz-4W_fieldRight" + " " + "yzz-4W_fieldBase",
  "fieldValue": "yzz-4W_fieldValue",
  "header": "yzz-4W_header",
  "headerTop": "yzz-4W_headerTop",
  "remark": "yzz-4W_remark",
  "row": "yzz-4W_row",
  "step": "yzz-4W_step",
  "stepNumber": "yzz-4W_stepNumber",
  "steps": "yzz-4W_steps",
});
